import React, { createContext, useContext, useCallback } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';

const HearingsContext = createContext();

export const useHearings = () => useContext(HearingsContext);

export const HearingsProvider = ({ children }) => {
  const createHearing = useCallback(async (data) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;

    try {
      const response = await api.post('/internals/hearings/', data, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      toast.success('Audiência criada com sucesso');
      return response.data;
    } catch (error) {
      const status = error?.response?.status;
      if (status !== 400) {
        const errData = error?.response?.data;
        const msg = errData?.detail || errData?.message || 'Erro ao criar audiência';
        toast.error(msg);
      }
      throw error;
    }
  }, []);

  const updateHearing = useCallback(async (id, data) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;
    try {
      const response = await api.patch(`/internals/hearings/${id}/`, data, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      toast.success('Audiência atualizada com sucesso');
      return response.data;
    } catch (error) {
      const status = error?.response?.status;
      if (status !== 400) toast.error('Erro ao atualizar audiência');
      throw error;
    }
  }, []);

  const startHearingProgress = useCallback(async (id) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;
    try {
      await api.post(`/internals/hearings/${id}/start-progress/`, {}, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      toast.success('Audiência iniciada');
    } catch (error) {
      toast.error('Erro ao iniciar audiência');
      throw error;
    }
  }, []);

  const updateHearingStatus = useCallback(async (id, data) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;
    try {
      const response = await api.patch(`/internals/hearings/${id}/update-status/`, data, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      toast.success('Status atualizado com sucesso');
      return response.data;
    } catch (error) {
      toast.error('Erro ao atualizar status');
      throw error;
    }
  }, []);

  const uploadHearingProof = useCallback(async (id, file) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      const response = await api.post(`/internals/hearings/${id}/upload-proof/`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      toast.success('Comprovante enviado com sucesso');
      return response.data;
    } catch (error) {
      toast.error('Erro ao enviar comprovante');
      throw error;
    }
  }, []);

  const listHearings = useCallback(async (params = {}) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return { count: 0, results: [] };

    try {
      const response = await api.get('/internals/hearings/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });
      return response.data || { count: 0, results: [] };
    } catch (error) {
      console.error('Erro ao listar audiências', error);
      toast.error('Erro ao buscar audiências');
      return { count: 0, results: [] };
    }
  }, []);

  return (
    <HearingsContext.Provider value={{ createHearing, updateHearing, listHearings, startHearingProgress, updateHearingStatus, uploadHearingProof }}>
      {children}
    </HearingsContext.Provider>
  );
};
